import {getTokenPayload} from "./jwt";
import ControleSessao from "../componentes-padrao/ControleSessao";



export const configureSession = (accessToken: string, refreshToken: string) => {
    accessToken = decodeURIComponent(accessToken)
    const data = getTokenPayload(accessToken)

    ControleSessao.setToken(accessToken);
    ControleSessao.setRefreshToken(refreshToken);

    const tokenClaims = data.authorization?.permissions[0].claims

    ControleSessao.setIdUsuario(Number(tokenClaims.CODIGO_USUARIO[0]));
    ControleSessao.setTipo(tokenClaims.TIPO_USUARIO[0]);
    ControleSessao.setNomeUsuario(tokenClaims.NOME_USUARIO[0]);

    if (tokenClaims.CODIGO_CLIENTE) {
        ControleSessao.setIdEmpresa(tokenClaims.CODIGO_CLIENTE[0])
    }
}
